import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';

import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';

import { linkColor } from '../styles';

const Wrapper = styled.div`
  margin-top: 24px;
`;

const ProvisionHeader = styled.div`
  margin-bottom: 10px;
  cursor: pointer;
  color: ${linkColor};
  text-decoration: none;
  font-size: 22px;
  font-weight: 400;

  &::after {
    content: '\u25BE';
    position: relative;
    display: inline-block;
    margin: 0 -1rem 0 0.5rem;
    transition: transform 300ms ease-in-out, top 300ms ease-in-out;
    transform-origin: center;
    ${props => props.isOpen ?
      `transform: rotate(180deg);
      top: 1px;` : ''}
  }
`;

const slidedownStyles = css`
  transition-duration: 300ms;
`;

class Provision extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  static get propTypes() {
    return {
      header: PropTypes.string,
    };
  }

  handleOpenToggle = () => {
    this.setState({ open: !this.state.open });
  }

  render() {
    return (
      <Wrapper>
        <ProvisionHeader children={this.props.header} isOpen={this.state.open} onClick={this.handleOpenToggle} />
        <SlideDown className={slidedownStyles}>
          {this.state.open ? this.props.children : null}
        </SlideDown>
      </Wrapper>
    );
  }
}

export default Provision;



// WEBPACK FOOTER //
// ./src/components/provision.js